/**
 * This function configures Webpack to use the dynamic public path being configured in `theme.liquid.`.
 * This file *must* be included at the top of every Webpack entrypoint; especially those which use
 * dynamic imports under the hood. Failure to include this file will result in 404s when loading split chunks.
 */
export default (() => {
  __webpack_public_path__ = window.__webpack_public_path__; // eslint-disable-line
})();
